<template>
    <a-config-provider :autoInsertSpaceInButton="false" :locale="locale" v-if="$route.meta.showQueryService">
        <div class="query-service">
            <a-breadcrumb separator=">">
                <a-breadcrumb-item>
                    <router-link to="/home">
                        <img src="../../assets/home/icon-home.svg" style="margin: 0 4px 4px 0" />首页
                    </router-link>
                </a-breadcrumb-item>
                <a-breadcrumb-item>{{ currentSubtitle }}</a-breadcrumb-item>
            </a-breadcrumb>

            <div class="query-service-body">
                <submenu-tabs title="查询服务" :tabs="leftTab" @changeTab="tabChanged" />

                <div class="right-content">
                    <div class="subtitle">{{ currentSubtitle }}</div>

                    <keep-alive>
                        <router-view></router-view>
                    </keep-alive>
                </div>
            </div>
        </div>
    </a-config-provider>

    <router-view v-else></router-view>
</template>

<script>
import SubmenuTabs from '../../components/submenu-tabs.vue';
import zhCN from 'ant-design-vue/es/locale/zh_CN';

export default {
    components: { SubmenuTabs },

    data() {
        return {
            locale: zhCN,
            leftTab: [
                // { name: '委托查询', id: 'entrustQuery' },
                { name: '报告查询', id: 'reportQuery' }
            ],
            currentSubtitle: ''
        };
    },

    methods: {
        tabChanged(tab) {
            this.currentSubtitle = tab.name;
            this.$router.push({ name: tab.id });
        }
    }
};
</script>

<style lang="scss" scoped>
.query-service {
    width: 1200px;
    padding-bottom: 94px;

    &-body {
        display: flex;
        align-items: flex-start;

        .submenu-tabs {
            flex-shrink: 0;
        }

        .right-content {
            flex-grow: 1;
            margin-left: 16px;
            background: #ffffff;
            border-radius: 4px;
            padding: 16px 24px;

            .subtitle {
                height: 48px;
                font-size: 24px;
                font-weight: 600;
                letter-spacing: 0;
                color: #005299;
                background: url(../../assets/test-service/split.png) bottom no-repeat;
            }
        }
    }
}
</style>
